// extracted by mini-css-extract-plugin
export default {"mCard":"cC-z","image":"dC-z","imageNoBackground":"eC-z","imageHasCategory":"fC-z","fullWidth":"gC-z"};